import { NgModule } from '@angular/core';

import { OktaLoginComponent } from './okta-login/okta-login.component';
import { OktaRedirectComponent } from './okta-redirect/okta-redirect.component';
import { SignoutComponent } from './signout/signout.component';

import { AuthRoutingModule } from './auth-routing.module';
import { SharedModule } from 'src/app/shared/shared.module';

const DECLARED = [OktaLoginComponent, OktaRedirectComponent, SignoutComponent];

@NgModule({
  imports: [SharedModule, AuthRoutingModule],

  declarations: [...DECLARED]
})
export class AuthModule {}
